import React from 'react';
import { useTenant } from '@/contexts/TenantContext';
import { BuildingOfficeIcon, MapPinIcon } from '@heroicons/react/24/outline';

interface TenantSiteInfoProps {
  compact?: boolean;
  showLabels?: boolean;
}

const TenantSiteInfo: React.FC<TenantSiteInfoProps> = ({ 
  compact = false, 
  showLabels = true 
}) => {
  const { activeTenant, activeSite, isLoading, error } = useTenant();

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2">
        <div className="animate-pulse bg-gray-200 h-4 w-20 rounded"></div>
        <div className="animate-pulse bg-gray-200 h-4 w-24 rounded"></div>
      </div>
    );
  }

  if (error) {
    // Ne pas afficher d'erreur, rester silencieux
    return null;
  }

  if (!activeTenant || !activeSite) {
    // Ne pas afficher de message, rester vide
    return null;
  }

  if (compact) {
    return (
      <div className="flex items-center space-x-3 text-xs text-gray-600">
        <div className="flex items-center space-x-1">
          <BuildingOfficeIcon className="h-3 w-3" />
          <span className="font-medium">{activeTenant.name}</span>
        </div>
        <div className="flex items-center space-x-1">
          <MapPinIcon className="h-3 w-3" />
          <span>{activeSite.name}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-4 text-sm">
      {showLabels && (
        <>
          <div className="flex items-center space-x-1 text-gray-600">
            <BuildingOfficeIcon className="h-4 w-4" />
            <span className="font-medium">Tenant:</span>
            <span className="text-gray-900">{activeTenant.name}</span>
            <span className="text-gray-500">({activeTenant.code})</span>
          </div>
          <div className="flex items-center space-x-1 text-gray-600">
            <MapPinIcon className="h-4 w-4" />
            <span className="font-medium">Site:</span>
            <span className="text-gray-900">{activeSite.name}</span>
            <span className="text-gray-500">({activeSite.code})</span>
          </div>
        </>
      )}
      {!showLabels && (
        <>
          <div className="flex items-center space-x-1">
            <BuildingOfficeIcon className="h-4 w-4 text-gray-400" />
            <span className="font-medium text-gray-900">{activeTenant.name}</span>
            <span className="text-gray-500">({activeTenant.code})</span>
          </div>
          <div className="flex items-center space-x-1">
            <MapPinIcon className="h-4 w-4 text-gray-400" />
            <span className="text-gray-900">{activeSite.name}</span>
            <span className="text-gray-500">({activeSite.code})</span>
          </div>
        </>
      )}
    </div>
  );
};

export default TenantSiteInfo;
